import script from "./Governance.vue?vue&type=script&lang=ts&setup=true"
export * from "./Governance.vue?vue&type=script&lang=ts&setup=true"

import "./Governance.vue?vue&type=style&index=0&id=09695bc0&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09695bc0"]])

export default __exports__